import {
    RESPONSE_STATUS,
    CLEAR_RESPONSE,
    GET_PROJECT_COMMENTS,
    GET_FETCH_DATA,
} from './productTypes'
export default (state, action) => {
    switch (action.type) {
        case GET_PROJECT_COMMENTS:
            return {
                ...state,
                project_comments: action.payload,
            }
        case GET_FETCH_DATA:
            return {
                ...state,
                search_fetch_data: action.payload,
            }
        case RESPONSE_STATUS:
            return {
                ...state,
                responseStatus: action.payload,
            }
        case CLEAR_RESPONSE:
            return {
                ...state,
                responseStatus: '',
            }
        default:
            return state
    }
}
